<template>
  <div class="view-tasklists account-lookup ">
    <user-menu />
    <div class="wrapper">
      <masteradmin-sidebar-menu v-if="masterAdmin == true" />
      <researcher-sidebar-menu v-if="researcher == true" />
      <CSRSidebarMenu v-if="csr == true" />
      <div class="content-wrapper">
      <div class="container-wrapper center report-dasboard" >

        <div class="col-12 override-padding">
          <h3 class="d-inline heading">Report Dashboard</h3>
        </div>
        <div class="heading-seperator"></div>
        <div style="margin-bottom: 15px;"></div>
        <div class="row">
          <div class="col-3 float-left">
            <div class="panel panel-grey">
              <div class="panel-heading">
                <div class="row">
                  <div class="col-3 float-left">
                    <i class="fa fa-cog"></i>
                  </div>
                  <div class="col-9 text-right float-right">
                    <div class="panel-main-title more-options-panel">Accounts</div>
                  </div>
                  <div style="clear: both"></div>
                </div>
              </div>
              <router-link to="/account-report">
                <div class="panel-footer">
                  <span class="pull-left">go to </span>
                  <span class="pull-right">
                    <i class="fa fa-chevron-right" aria-hidden="true"></i>
                  </span>
                  <div class="clearfix"></div>
                </div>
              </router-link>
            </div>
          </div>

          <div class="col-3 float-left">
            <div class="panel panel-grey">
              <div class="panel-heading">
                <div class="row">
                  <div class="col-3 float-left">
                    <i class="fa fa-user"></i>
                  </div>
                  <div class="col-9 text-right float-right">
                    <div class="panel-main-title more-options-panel">Account Contacts</div>
                  </div>
                  <div style="clear: both"></div>
                </div>
              </div>
              <router-link to="/account-contact-report">
                <div class="panel-footer">
                  <span class="pull-left">go to </span>
                  <span class="pull-right">
                    <i class="fa fa-chevron-right" aria-hidden="true"></i>
                  </span>
                  <div class="clearfix"></div>
                </div>
              </router-link>
            </div>
          </div>


          <div class="col-3 float-left" v-if="masterAdmin == true">
            <div class="panel panel-grey">
              <div class="panel-heading">
                <div class="row">
                  <div class="col-3 float-left">
                    <i class="fa fa-user"></i>
                  </div>
                  <div class="col-9 text-right float-right">
                    <div class="panel-main-title more-options-panel">Activity Report</div>
                  </div>
                  <div style="clear: both"></div>
                </div>
              </div>
              <router-link to="/activity-report">
                <div class="panel-footer">
                  <span class="pull-left">go to </span>
                  <span class="pull-right">
                    <i class="fa fa-chevron-right" aria-hidden="true"></i>
                  </span>
                  <div class="clearfix"></div>
                </div>
              </router-link>
            </div>
          </div>

          <div class="col-3 float-left" v-if="masterAdmin == true">
            <div class="panel panel-grey">
              <div class="panel-heading">
                <div class="row">
                  <div class="col-3 float-left">
                    <i class="fa fa-user"></i>
                  </div>
                  <div class="col-9 text-right float-right">
                    <div class="panel-main-title more-options-panel">Flash Report</div>
                  </div>
                  <div style="clear: both"></div>
                </div>
              </div>
              <router-link to="/flash-report">
                <div class="panel-footer">
                  <span class="pull-left">go to </span>
                  <span class="pull-right">
                    <i class="fa fa-chevron-right" aria-hidden="true"></i>
                  </span>
                  <div class="clearfix"></div>
                </div>
              </router-link>
            </div>
          </div>

          <div class="col-3 float-left">
            <div class="panel panel-grey">
              <div class="panel-heading">
                <div class="row">
                  <div class="col-3 float-left">
                    <i class="fa fa-cog"></i>
                  </div>
                  <div class="col-9 text-right float-right">
                    <div class="panel-main-title more-options-panel">Usage Report</div>
                  </div>
                  <div style="clear: both"></div>
                </div>
              </div>
              <router-link to="/usage-report">
                <div class="panel-footer">
                  <span class="pull-left">go to </span>
                  <span class="pull-right">
                    <i class="fa fa-chevron-right" aria-hidden="true"></i>
                  </span>
                  <div class="clearfix"></div>
                </div>
              </router-link>
            </div>
          </div>

          <div class="col-3 float-left">
            <div class="panel panel-grey">
              <div class="panel-heading">
                <div class="row">
                  <div class="col-3 float-left">
                    <i class="fa fa-cog"></i>
                  </div>
                  <div class="col-9 text-right float-right">
                    <div class="panel-main-title more-options-panel">Mentee Report</div>
                  </div>
                  <div style="clear: both"></div>
                </div>
              </div>
              <router-link to="/mentee-report">
                <div class="panel-footer">
                  <span class="pull-left">go to </span>
                  <span class="pull-right">
                    <i class="fa fa-chevron-right" aria-hidden="true"></i>
                  </span>
                  <div class="clearfix"></div>
                </div>
              </router-link>
            </div>
          </div>

          <div style="clear: both"></div>
        </div>






      </div>
      </div>
    </div>
  </div>
</template>

<script>

import Vue from 'vue/dist/vue.esm';
import UserMenu from '../../shared/user_menu.vue';
import MasteradminSidebarMenu from '../../shared/masteradmin_sidebar_menu.vue';
import axios from 'axios';
import { store } from '../../../store/store';
import router from '../../../router/index.js';
import ResearcherSidebarMenu from '../../shared/researcher_sidebar_menu.vue';
import CSRSidebarMenu from '../../shared/csr_sidebar_menu.vue';

export default {
        data() {
          return {
            researcher: false,
            masterAdmin: false,
            csr: false,
          }
        },
        components: {
          UserMenu,
          MasteradminSidebarMenu,
          ResearcherSidebarMenu,
          CSRSidebarMenu,
        },
        created() {
          var roles = this.$store.state.roles;
          if(roles.indexOf('ROLE_MASTER_ADMIN') > -1) {
            this.masterAdmin = true;
          }
          if(roles.indexOf('ROLE_RESEARCHER') > -1) {
            this.researcher = true;
          }
          if(roles.indexOf('ROLE_CSR') > -1) {
            this.csr = true;
          }

        },


}

</script>

<style scoped>
.panel {
    margin-bottom: 20px;
    background-color: #fff;
    border: 1px solid transparent;
    border-radius: 0px;
    -webkit-box-shadow: 0 1px 1px rgb(0 0 0 / 5%);
    box-shadow: 0 1px 1px rgb(0 0 0 / 5%);
}
.panel-grey {
    border-color: #cccccc;
}
.panel-grey > .panel-heading {
    background-color: #ccc;
    border-color: #ccc;
    padding: 10px 15px;
    border-bottom: 1px solid transparent;
}
.report-dasboard .row {
  display: block;
}
.panel-main-title {
    text-transform: uppercase;
    font-weight: bold;
    color: #6d6e70;
}
.panel-footer {
    padding: 10px 15px;
    background-color: #f5f5f5;
    border-top: 1px solid #ddd;
    border-bottom-right-radius: 3px;
    border-bottom-left-radius: 3px;
}
.fa-cog, .fa-user {
  font-size: 45px;
  color: #FFF;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/reports/report_dashboard.vue